import { render, staticRenderFns } from "./object.tabs.vue?vue&type=template&id=3ff94309&"
import script from "./object.tabs.vue?vue&type=script&lang=ts&"
export * from "./object.tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports